module.exports = __webpack_public_path__ + "img/Sommerurlaub.8f3db90b.jpg";